export default __webpack_public_path__ + "static/media/icon-orderFinished.2a99c9ad.svg";